import axiosInstance from '../../../config/axiosInstance';
import { SupplierDiscountValidation } from "../View/Validation/SupplierDiscountValidation";

const handleChange = (event, formData, setFormData) => {
    const { name, value } = event.target;
    setFormData({
        ...formData,
        [name]: value,
    });
};
const handleSubmit = async (event, formData, setFormData, setErrors, redirectCallback, redirectRoleList) => {
    event.preventDefault();
   const formErrors = SupplierDiscountValidation(formData);
   setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
        try {
            const CompanyID = localStorage.getItem("CompanyID");
            formData.ClientID = CompanyID;
            const UserID = localStorage.getItem("UserID");
            formData.UserID = UserID;
            const response = await axiosInstance.post(`/Supplier/CreateSupplierDiscount`, formData);
            return response.data;
        } catch (error) {
            debugger;
            console.error('Error posting data:', error);
        }
    }
};

export { handleChange, handleSubmit };
